import { type ServiceAddress } from './service-address';

export class DataViewerRequest {
  RequestType?: string;
  FirstName?: string;
  LastName?: string;
  AccountID?: string;
  Seasonal?: string;
  SaID?: string;
  SaTypeCode?: string;
  PastDueBalance?: string;
  ReconnectType?: string;
  AccountEmail?: string;
  EmailAddress?: string;
  PhoneNumber?: string;
  PhoneType?: string;
  OldAddress?: ServiceAddress;
  TurnOffDate?: string;
  InstructionsForMeterStop?: string;
  DetailedInstructions?: string;
  ReasonForTurnoff?: string;
  ServiceType?: string;
  StartDate?: string;
  TimeAvailable?: string;
  ServiceAddress?: ServiceAddress;
  MailingAddressDifferent?: boolean;
  MailingAddressUseNewAddressOnAllAccounts?: boolean;
  MailingAddress?: ServiceAddress;
  RaterPlanPackageId?: string;
  RatePlanSelected?: string;
  RatePlanTerm?: string;
  DiscountCode?: string;
  OrderID?: string;
  SortOrder?: string;
  CustomerServiceFee?: string;
  ServiceRequestSubmissionTime?: string;
  ExternalAccountId?: string;
  Bankname?: string;
  CardExpDate?: string;
  CardNumber?: string;
  CardType?: string;
  TransferAutopay?: string;
  TransferAuthorizedUser?: string;
  BillDeliveryOptions?: string;
  AuthorizedUsers?: string;
  InstructionsForMeterStart?: string;
  BudgetBillAmount?: string;
}

// {
//   "RequestType": "Transfer",
//   "FirstName": "Chloe",
//   "LastName": "Ashe",
//   "AccountID": "5516099435",
//   "Seasonal": false,
//   "SaID": "5510807896",
//   "SaTypeCode": "RESGAS",
//   "PastDueBalance": "0.00",
//   "ReconnectType": null,
//   "AccountEmail": "louashe1302@gmail.com",
//   "PhoneNumber": "678-910-5322",
//   "PhoneType": "Mobile",
//   "OldAddress": {
//     "Order": 0,
//     "PremiseId": null,
//     "SaId": null,
//     "SaStatusFlg": null,
//     "SaEndDate": null,
//     "Address1": "2607 paces rdg # e",
//     "Address2": "",
//     "City": "Atlanta",
//     "State": "GA",
//     "PostalCode": "30339",
//     "Country": "USA",
//     "IsResidential": false,
//     "SaTypeCode": null,
//     "FullAddress": "2607 paces rdg # e Atlanta GA 30339",
//     "SaRateScheduleCode": null,
//     "BillingRateExpirationDate": null
//   },
//   "TurnOffDate": "9/2/2025",
//   "InstructionsForMeterStop": "None",
//   "DetailedInstructions": null,
//   "ReasonForTurnoff": "Move",
//   "ServiceType": "TO",
//   "StartDate": "9/2/2025",
//   "TimeAvailable": "8am - 12pm",
//   "ServiceAddress": {
//     "Order": 0,
//     "PremiseId": "",
//     "SaId": null,
//     "SaStatusFlg": null,
//     "SaEndDate": null,
//     "Address1": "2627 Paces Ridge",
//     "Address2": "Apt J",
//     "City": "Atlanta",
//     "State": "GA",
//     "PostalCode": "30339",
//     "Country": "USA",
//     "IsResidential": false,
//     "SaTypeCode": null,
//     "FullAddress": "2627 Paces Ridge Apt J Atlanta GA 30339",
//     "SaRateScheduleCode": null,
//     "BillingRateExpirationDate": null
//   },
//   "MailingAddressDifferent": false,
//   "MailingAddressUseNewAddressOnAllAccounts": false,
//   "MailingAddress": {
//     "Order": 0,
//     "PremiseId": "",
//     "SaId": null,
//     "SaStatusFlg": null,
//     "SaEndDate": null,
//     "Address1": "2627 Paces Ridge",
//     "Address2": "Apt J",
//     "City": "Atlanta",
//     "State": "GA",
//     "PostalCode": "30339",
//     "Country": "USA",
//     "IsResidential": false,
//     "SaTypeCode": null,
//     "FullAddress": "2627 Paces Ridge Apt J Atlanta GA 30339",
//     "SaRateScheduleCode": null,
//     "BillingRateExpirationDate": null
//   },
//   "RaterPlanPackageId": "RESFIX12",
//   "RatePlanSelected": "12 Month Fixed Rate @ 73¢ Per Therm",
//   "RatePlanTerm": "0.73",
//   "DiscountCode": "",
//   "OrderID": "",
//   "SortOrder": "1",
//   "CustomerServiceFee": "9.95",
//   "ServiceRequestSubmissionTime": "2025-09-02 06:09:56",
//   "ExternalAccountId": "",
//   "Bankname": "",
//   "CardExpDate": "",
//   "CardNumber": "",
//   "CardType": "",
//   "TransferAutopay": "N",
//   "TransferAuthorizedUser": "N",
//   "BillDeliveryOptions": "Y",
//   "AuthorizedUsers": null,
//   "InstructionsForMeterStart": null,
//   "BudgetBillAmount": null
// }
